export default __webpack_public_path__ + "static/media/TFC.ede79fb0.png";